import React from "react";

const SellerReports = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Reports & Analytics</h1>

      <div className="bg-white p-4 rounded-xl shadow">
        <img
          src="https://img.freepik.com/premium-vector/line-graph-trend-data-infographic-chart_123447-13127.jpg"
          alt="Sales Graph"
          className="rounded-lg w-full"
        />
      </div>
    </div>
  );
};

export default SellerReports;
